import { render, staticRenderFns } from "./VesselNotes.vue?vue&type=template&id=117a8660&"
import script from "./VesselNotes.vue?vue&type=script&lang=ts&"
export * from "./VesselNotes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports